module.exports = __webpack_public_path__ + "img/chart-line-area-single.b830bc91.svg";